export enum PADDING_INPUT_SET_TYPES {
  ALL = 'all',
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
